import React from 'react';
import { useTranslation } from 'next-i18next';
import PropTypes from 'prop-types';

import ProductToastBody from '@components/product/ProductToastBody/ProductToastBody';
import * as ProductHelpers from '@helpers/ProductHelpers';
import { useAnalytics } from '@hooks/useAnalytics';
import { useConfig } from '@hooks/data/useConfig';
import { useOrderProductMutation } from '@hooks/data/useOrderProductMutation';

/* import styles from './ProductDeleteToastBody.module.scss'; */

const ProductDeleteToastBody = (props) => {

  const {
    order, orderItem, listProps = {}, onSuccess,
  } = props;

  const {
    isOk, quantity, productName: name, image
  } = orderItem || {};

  const analytics = useAnalytics();
  const { data: config } = useConfig();
  const { errors } = config || {};
  const { t } = useTranslation();
  const { add: addProduct } = useOrderProductMutation();

  const handleAdd = (e) => {
    e.preventDefault();

    addProduct({
      product: orderItem,
      quantity,
      bypassAddressRequirement: true,
      bypassQuantityVariants: true,
      listProps,
      order,
      onSuccess: () => {
        ProductHelpers.checkMaxQuantityReached(0, 1, orderItem, errors, { analytics });
        if (onSuccess) {
          onSuccess();
        }
      },
    });
  };

  return (
    <ProductToastBody
      product={{ name, image }}
      message={t('NOTIFICATIONS.PRODUCT_DELETED')}
      button={
        isOk
          ? {
            props: { onClick: handleAdd },
            label: t('NOTIFICATIONS.PRODUCT_DELETED_UNDO')
          } : null
      }
    />
  );
};

ProductDeleteToastBody.propTypes = {
  orderItem: PropTypes.shape({}).isRequired,
  order: PropTypes.shape({}),
  listProps: PropTypes.shape({}),
  onSuccess: PropTypes.func
};

export default ProductDeleteToastBody;
